export const faqData = [
  {
    "question": "Q1: Is Women’s Bible free to use?",
    "answer": "A: Yes! You can access Bible readings, devotionals, and prayers for free. Some premium features may be added later, but the core experience will always stay free."
  },
  {
    "question": "Q2: What version of the Bible does it use?",
    "answer": "A: The app uses the King James Version (KJV), known for its timeless language and faithfulness to Scripture."
  },
  {
    "question": "Q3: Who writes the devotionals and prayers?",
    "answer": "A: All devotionals and prayers are created by Christian women writers and ministry partners who share a heart for encouraging women through God’s Word."
  },
  {
    "question": "Q4: Can I post prayer requests anonymously?",
    "answer": "A: Yes. You can choose to share with your name or remain anonymous when posting in Assist."
  },
  {
    "question": "Q5: How can I help others in the app?",
    "answer": "A: Simply visit the Assist section to read prayer requests and leave a kind message or Bible verse to encourage others."
  },
  {
    "question": "Q6: Are the quizzes suitable for beginners?",
    "answer": "A: Absolutely! The Bible Quiz offers questions at all levels, from beginner to advanced, so everyone can learn at their own pace."
  },
  {
    "question": "Q7: Can I read offline?",
    "answer": "A: Yes. Once you open a passage or devotional, it’s automatically saved so you can access it even without internet connection."
  },
  {
    "question": "Q8: Is this app only for women?",
    "answer": "A: It’s designed especially for women’s faith journeys, but anyone who seeks encouragement in Christ is welcome."
  },
  {
    "question": "Q9: Will I get daily reminders for devotionals?",
    "answer": "A: Yes, you can enable gentle notifications to remind you of morning and evening prayers or your daily reading."
  },
  {
    "question": "Q10: Is my data private and secure?",
    "answer": "A: Yes. We never share your personal data or prayer posts outside the app. Your privacy and safety come first."
  }
  ,
  {
    "question": "Q11: Can I invite my friends to use the app?",
    "answer": "A: Of course! You can share devotionals or invite friends directly through the app to join the community."
  },
  {
    "question": "Q12: What makes Women’s Bible different from other Bible apps?",
    "answer": "A: It’s built for connection, not just content — combining prayer, Scripture, and sisterhood to create a daily space for women to grow in faith together."
  }
]
